const TEXT_FIELD_YEAR_MAX_LENGTH = 4;

/**
 * Get days for Date of Birth verification form for the guest login
 * @param month
 * @returns number of days of that month:
 *  - For the month = 2 , 29 days returned to be able to check leap year.
 *    If its leap year, 29 is allowed else its invalid)
 */
export const DOBFormGetDaysInMonth = (month: number): number => {
  if (month === 2) {
    return 29;
  }
  return [4, 6, 9, 11].includes(month) ? 30 : 31;
};

/**
 * Validate Date of Birth verification form day input for the leap years
 * @param day
 * @param month
 * @param year
 * @returns false if its not a leap year and 29th day entered
 */
export const DOBFormValidateDay = (
  day: string,
  month: number,
  year: string
): boolean => {
  const dayNumber = parseInt(day, 10);
  const yearNumber = parseInt(year, 10);

  if (month !== 2) return true;

  const isLeapYear =
    yearNumber % 4 === 0 && (yearNumber % 100 !== 0 || yearNumber % 400 === 0);

  if (dayNumber === 29 && !isLeapYear) {
    return false;
  }

  return true;
};

export const validateYear = (value: string): boolean => {
  const yearNumber = parseInt(value, 10);
  const currentYear = new Date().getFullYear();
  if (
    value.length !== TEXT_FIELD_YEAR_MAX_LENGTH ||
    isNaN(yearNumber) ||
    yearNumber < 1900 ||
    yearNumber > currentYear
  ) {
    return false;
  }
  return true;
};
